import React from 'react';
import LocalizedStrings from 'react-localization';
import Widget from '../Widget/Widget'
import Slider from 'react-slick'
import './ResourceNextBookingWidget.css'
import {chunkArray, flatten} from '../../../Utils/ArrayUtils'

class ResourceNextBookingWidget extends React.Component {

  constructor(props) {
    super(props);
    this.strings = new LocalizedStrings({
     en:{
       noMeetings: 'There are no upcoming meetings',
       meetingDetail: '- {0}, from {1} to {2}',
       total: 'Total: '
     },
     de: {
       noMeetings: 'Keine weiteren Termine gebucht',
       meetingDetail: '- {0}, von {1} bis {2}',
       total: 'Insgesamt: '
     }
    });

    if(props.language) {
      this.strings.setLanguage(props.language);
    }
  }

  getresourceslides() {
    if(this.props.resources) {
      const resources = this.props.resources;
      var resourceslides = Object.keys(resources).map(function(key) {
          const resource = resources[key];
          const attendees = resource.attendees;

          var columnSize = 6;
          var colClass = 'col-2';

          const windowWidth = window.innerWidth;

          if(windowWidth >= 2000) {
            colClass = "col-2"
          } else if(attendees.length <= 3) {
            colClass="col-4"
          } else if(attendees.length < 6) {
            colClass = "col"
          }

          var rows = [];

          const numberOfRows = Math.ceil(attendees.length / columnSize);
          const numberOfColumns = Math.ceil(attendees.length / numberOfRows)

          var attendeesChunks = chunkArray(attendees, numberOfColumns);

          for(var i = 0; i < attendeesChunks.length; i++) {
            var attendeesColumns = attendeesChunks[i];

            var columns = [];

            for(var j = 0; j < attendeesColumns.length; j++) {
              const attendee = attendeesColumns[j];

              columns.push(
                <div className={colClass} key={attendee.id}>
                  <img src={attendee.image} alt={attendee.name} className='rounded-circle img-fluid resource-next-booking-widget-img mx-auto d-block'/>
                </div>
              )

            }

            rows.push(
              <div key={'row'+i} className="row align-items-center justify-content-center resource-next-booking-widget-row">
                {columns}
              </div>
            )
          }

          var rowsForSlides = chunkArray(rows, 2);

          return rowsForSlides.map(function(rowsForSlide, index) {
            return this.buildSlide(key+"-"+index, key, resource.title, resource.startDate, resource.startTime, resource.endTime, rowsForSlide, attendees.length)
          },this)

      }, this)

      return flatten(resourceslides);
    }
  }

  buildSlide(key, resource, meetingName, date, startTime, endTime, rows, attendeecount) {
    return (
      <div key={key}>
        <div className="resource-next-booking-widget-slide">
          <h1 className="text-center">{resource}</h1>
          <div className="row align-items-center justify-content-center">
            <div className="col">
              <p className="text-center resource-next-booking-widget-slide-attendee-count-text">{ meetingName }{ this.strings.formatString(this.strings.meetingDetail, date, startTime, endTime) }</p>
            </div>
          </div>
          {rows}
          <div className="row align-items-center justify-content-center">
            <div className="col">
              <p className="text-center resource-next-booking-widget-slide-attendee-count-text">{ this.strings.total }{attendeecount}</p>
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {

    var settings = {
     dots: true,
     infinite: true,
     speed: 500,
     slidesToShow: 1,
     slidesToScroll: 1,
     arrows:false,
     draggable:false,
     autoplay:true,
     autoplaySpeed:5000,
     pauseOnHover:false
    };

    const resourceslides = this.getresourceslides();

    if (resourceslides && resourceslides.length === 1) {
      settings.autoplay = false;
      settings.infinite = false;
    }

    if(resourceslides && resourceslides.length > 0) {
      return (
        <Widget {...this.props}>
          <div className="row widget-fullheight-row">
            <div className="col align-self-center">
              <Slider {...settings}>
                {resourceslides}
              </Slider>
            </div>
          </div>
        </Widget>
      )
    } else {
      return (<Widget {...this.props}>
        <div className="row widget-fullheight-row">
          <div className="col align-self-center">
            <h1 className="text-center">{ this.strings.noMeetings }</h1>
          </div>
        </div>
      </Widget>)
    }
  }
}

export default ResourceNextBookingWidget;



// WEBPACK FOOTER //
// ./src/components/Dashboard/components/ResourceNextBookingWidget/ResourceNextBookingWidget.js